import React from 'react';
import TwoThreeRows from "../layouts/TwoThreeRows/TwoThreeRows";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import BlankComponent from "../components/BlankComponent/BlankComponent";
import {NavLink} from "react-router-dom";

const ship = () => {
  return (
    <BlankComponent>
      <div className="mbl">
        <TwoThreeRows
          rows={3}
          
          mainPanel={
            <ContentPanel
              skeleton={<Skeleton type="MAIN_PANEL"/>}
              errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
              templateUrl="./content/ship/page-components/text-block/ship-landing-heading.html"
            />
          }
    
          contentPanel1={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/ship/page-components/article/ship-landing/start-shipping-tile-1.html"
            />
          }
    
          contentPanel2={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/ship/page-components/article/ship-landing/start-shipping-tile-2.html"
            />
          }
    
          contentPanel3={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/ship/page-components/article/ship-landing/shipping-checklist.html"
            />
          }
        />
      </div>
      <div className="two-three-rows__footer background-primary-blue">
        <div className="wrapper">
          <div className="ship-footer">
            <div className="ship-footer__image-container">
              <img src="./assets/ship/ship-apply.png" alt="" className="ship-footer__image"/>
            </div>
            <div className="ship-footer__text-block">
              <h3 className="h3 ship-footer__title color-white">Apply for an account</h3>
              <p className="color-white">Whether you’re an individual, small or large business, Southwest Cargo can get your shipment where it needs to go. Click the button below to submit an application.</p>
              <div className="ship-footer__cta-button-container">
                <NavLink to="/ship/apply" className="ship-footer__cta-button cta-button">Apply now</NavLink>
              </div>
              <a href="./pdf/TranslatedPDFApplication-0718.pdf" target="_blank" className="ship-footer__text color-white">El formulario de Español</a>
            </div>
          </div>
        </div>
      </div>
    </BlankComponent>
  )
};

export default ship;



// WEBPACK FOOTER //
// ./src/pages/Ship.js